import * as Utils from './cmpUtils';

export default class Utag {
  constructor(settings) {
    this.libraryFound = false;
    this.host = window.location.host;
    this.validEventTypes = ['view', 'link'];
    this.isLocal = this.checkLocal();
    this.options = {
      // default page id's for onLoad tags
      page_paths: {},

      // control whether or not onLoad page tags fire
      call_page_tags: true,

      // use html attributes for element tags
      use_attribute_tags: true,

      // the name of the attribute tags
      attribute_tag: 'utag',
    };
    Object.assign(this.options, settings);
    this.init();
  }
  checkLocal(host = window.location.host) {
    if (host === 'localhost:8081') {
      return true;
    }
    return false;
  }
  init() {
    // check to see if  library connected
    this.libraryFound = this.checkForLibrary();
    if (this.libraryFound || this.isLocal) {
      Utils.log('Library Initiated');

      // listen for html elements tags
      this.initAttributeListener();

      // call on load page event
      this.initPageLoadCall();
    } else {
      // could not connect to coremetrics
      Utils.log('ERROR: Could not find library (from init method)');
    }
  }
  checkForLibrary() {
    if (window.utag) {
      return true;
    }
    return false;
  }
  initAttributeListener() {
    const _this = this;
    if (this.options.use_attribute_tags) {
      const el = document.querySelectorAll(`[${this.options.attribute_tag}]`);

      Utils.forEach(el, (index, value) => {
        value.onclick = function () {
          _this.fireTag('link', {
            event_name: value.getAttribute(_this.options.attribute_tag),
          });
        };
      });
    }
  }
  initPageLoadCall() {
    if (this.options.page_paths !== {} && this.options.call_page_tags) {
      const page = this.options.page_paths[this.path()];
      if (page) {
        this.fireTag('view', {
          page_type: 'marketing',
          page_name: page,
        });
      }
    }
  }
  checkTag(type, params) {
    if (!this.libraryFound && !this.isLocal) {
      Utils.log('ERROR: Library not found');
      return false;
    } else if (type === undefined || type === '') {
      Utils.log('checkTag ERROR: No type defined');
      return false;
    } else if (this.validEventTypes.indexOf(type) === -1) {
      Utils.log('checkTag ERROR: Invalid tag type');
      return false;
    } else if (params === undefined || params === {}) {
      Utils.log('checkTag ERROR: Params not set');
      return false;
    }
    console.log('checkTag: pass');
    return true;
  }
  fireTag(type, params) {
    if (this.checkTag(type, params)) {
      Utils.log(`fireTag: Type: ${type} Params: ${JSON.stringify(params)}`);
      if (!this.isLocal) {
        window.utag[type](params);
      }
    }
  }
  path() {
    const urlArr = window.location.pathname.split('/');
    if (urlArr[urlArr.length - 1] === '') {
      return urlArr[urlArr.length - 2];
    }
    return urlArr[urlArr.length - 1];
  }
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/js/cmpUtag.js